import type { HolderType } from '../../data/types';

export interface ApplyForm {
  fundId: string;
  classId: string;
  amount: string;
  holderId: string;
  applicantType: HolderType;
  applicantName: string;
  contactName: string;
  email: string;
  abn: string;
  owners: { name: string; role: string }[];
  idVerified: boolean;
  tfn: string;
  residency: string;
  usPerson: boolean;
  bankName: string;
  bsb: string;
  account: string;
  certificate: string;
  signature: string;
  agree: boolean;
}

export interface StepProps {
  form: ApplyForm;
  update: (patch: Partial<ApplyForm>) => void;
  existingHolder: boolean;
}

export const APPLY_STEPS = [
  'Investment',
  'Entity',
  'Owners',
  'Identity',
  'Tax',
  'Bank',
  'Eligibility',
  'Review & sign',
] as const;
